import FooterColumn from "./FooterColumn";
import { ReactComponent as XIcon } from "../assets/Social-Icons--X.svg";
import { ReactComponent as DiscordIcon } from "../assets/Social-Icons--Discord.svg";
import { ReactComponent as GithubIcon } from "../assets/Social-Icons--Github.svg";
import Logo from "../assets/Logo-OpenMind_black.svg";
import Icon from "../assets/Icon-OpenMind.svg";

const Footer = () => {
  const buildingLinks = [
    { name: "OM1", url: "/#om1" },
    { name: "FABRIC", url: "/#fabric" },
    { name: "Blog", url: "/blog" },
  ];
  const companyLinks = [
    { name: "Vision", url: "/about/#vision" },
    {
      name: "Careers",
      url: "https://www.linkedin.com/company/openmindagi/jobs/",
    },
    { name: "Contact Us", url: "mailto:hello@openmind.org" },
  ];
  const developerLinks = [
    { name: "Documents", url: "https://docs.openmind.org/" },
    { name: "Github", url: "https://github.com/OpenmindAGI" },
  ];

  return (
    <footer className="p-14 pb-5 max-md:px-8 max-sm:px-4">
      <div className="my-0 max-w-[1920px]">
        <div className="flex justify-between items-start mb-40 max-md:flex-wrap max-md:gap-8 max-sm:flex-col max-sm:gap-5 max-sm:mb-10">
          <img
            src={Logo}
            alt="OpenMind Logo"
            className="pb-7 h-12 w-auto hidden max-sm:block"
          />
          <img
            src={Icon}
            alt="OpenMind Icon"
            className="h-8 w-auto block max-sm:hidden"
          />
          <div className="flex gap-12 justify-end max-md:flex-wrap max-md:gap-8 max-sm:flex-col max-sm:gap-8">
            <FooterColumn title="Building" links={buildingLinks} />
            <FooterColumn title="Company" links={companyLinks} />
            <FooterColumn title="Developers" links={developerLinks} />
            <FooterColumn title="Community">
              <div className="flex gap-5">
                <a
                  href="https://x.com/openmind_agi"
                  className="hover:opacity-80"
                  aria-label="Twitter"
                >
                  <XIcon width={19} height={19} />
                </a>
                <a
                  href="https://discord.com/invite/VUjpg4ef5n"
                  className="hover:opacity-80"
                  aria-label="Discord"
                >
                  <DiscordIcon width={19} height={19} />
                </a>
                <a
                  href="https://github.com/OpenmindAGI"
                  className="hover:opacity-80"
                  aria-label="GitHub"
                >
                  <GithubIcon width={19} height={19} />
                </a>
              </div>
            </FooterColumn>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center max-sm:hidden">
        <p className="text-base tracking-tight text-gray-600">
          © 2025 OpenMind AGI. All Rights Reserved.
        </p>
        <div className="flex gap-20 max-md:gap-8 max-sm:flex-col">
          <a href="/terms" className="text-base tracking-tight text-gray-600">
            Terms of use
          </a>
          <a href="/privacy" className="text-base tracking-tight text-gray-600">
            Privacy Policy
          </a>
        </div>
      </div>
      <div className="flex justify-between items-end w-full mb-4 sm:hidden">
        <div className="flex flex-col justify-end">
          <p className="text-base tracking-tight text-gray-600">
            © 2025 OpenMind
          </p>
        </div>
        <div className="flex gap-8 max-sm:flex-col max-sm:gap-2.5 text-right">
          <a
            href="/terms"
            className="text-base tracking-tight text-gray-600 underline"
          >
            Terms of use
          </a>
          <a
            href="/privacy"
            className="text-base tracking-tight text-gray-600 underline"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
